<template>
  <router-view />
</template>
<script>
// import terminalService from '../../api/terminal';

export default {
  name: 'authentication'
};
</script>
<style scoped>
#login {
  /* background-image:url(https://picsum.photos/1200/?random&gravity=east);
    background-size: cover; */
  background-color: #ebedf1;
}
</style>
